import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { FormValidator } from '../../../../_helpers/form.validator';
import { EaselValidator } from '../../easel.validator';

import { Easel} from '../../../../_models/easel';
import { EaselType } from '../../../../_models/easel_type';
import { EaselFamily } from '../../../../_models/easel_family';
import { Product } from '../../../../_models/product';


@Component({
  selector: 'app-easel-edit',
  templateUrl: './easel-edit.component.html'
})

export class EaselEditComponent implements OnInit {

  title: string;
  subtitle: string;

  easelForm: FormGroup;

  actionModal: boolean;
  alertModal: boolean;
  infoModal: boolean;

  actionInfo: string;
  alertInfo: string;
  infoInfo: string;


  // Variable para el control de las validaciones del formulario y sus mensajes.
  formValidator: FormValidator;

  easelTypeListAux: EaselType[];
  easelFamilyListAux: EaselFamily[];
  freightListAux: Product[];


  @Input() easel: Easel;
  @Input() easelTypeList: EaselType[];
  @Input() easelFamilyList: EaselFamily[];
  @Input() freightList: Product[];
  @Output() updateEasel = new EventEmitter<Easel>();
  @Output() showInfoModal = new EventEmitter<{ value: boolean, info: string, link: string, skin: string }>();

  constructor(
    public router: Router,
    private formBuilder: FormBuilder
  ) {
    this.formValidator = new FormValidator();
  }

  ngOnInit() {

    this.easelForm = this.formBuilder.group({
      name: [this.easel.name, Validators.required],
      desc: this.easel.desc,
      type: [this.easel.type, Validators.required],
      family: [this.easel.family, Validators.required],
      sides: this.easel.sides,
	    stacks: this.easel.stacks,
      height: [this.easel.height, Validators.required],
      width: [this.easel.width, Validators.required],
      depth: [this.easel.depth, Validators.required],
      weight: this.easel.weight,
      max_height: this.easel.max_height,
      max_width: this.easel.max_width,
      thickness: this.easel.thickness,
      max_weight: this.easel.max_weight,
      separator: this.easel.separator,
      stack_distance: this.easel.stack_distance,
      priority: this.easel.priority !== undefined && this.easel.priority !== null ? this.easel.priority : 999,
      safety_margin: this.easel.safety_margin,
      cost_m3: this.easel.cost_m3,
      active: this.easel.active
    });

    if (this.easel.type === undefined || this.easel.type === null) {
      this.easelForm.controls.type.setValue(3);
    }

    this.easelForm.controls.type.disable();
    // this.easelForm.controls.family.disable();

    // Asignamos los mensajes de error asociados a las validaciones que vamos a usar en el formulario.
    this.formValidator.setTemplateMessages(EaselValidator.templateMessages);

    this.title = 'Módulo de Caballetes';
    this.subtitle = 'Edición de Caballetes';

    this.actionInfo = '¿Desea guardar el caballete?';

    this.infoInfo = 'La acción se ha realizado correctamente.';


    // Se crean las subscripciones para el control de los campos del formulario.
    this.formValidator.subscribeFormGroup(this.easelForm);

    this.easelTypeListAux = this.easelTypeList;
    this.easelFamilyListAux = this.easelFamilyList;
    this.freightListAux = this.freightList;

    // Se asigna el tipo cargado para que se actualice también el selector de familia.
    this.easelFamilyListAux = this.easelFamilyList.filter( item => this.easelForm.controls.type.value === item.easel_type_id);

  } // End function ngOnInit

  // convenience getter for easy access to form fields
  get f() { return this.easelForm.controls; }


  saveEasel(): void {

    // this.easel.weight = this.easelForm.controls.weight.value;
    // this.easel.weight = this.easelForm.controls.width.value;
    // this.easel.max_height = this.easelForm.controls.height.value;
    // this.easel.thickness = this.easelForm.controls.depth.value;

    this.easelForm.controls.type.enable();
    // this.easelForm.controls.family.enable();

    // NOTA: Se copian los cambios sobre la caballete inicial.
    const p = { ...this.easel, ...this.easelForm.value };

    this.updateEasel.emit(p);

    this.easelForm.controls.type.disable();
    // this.easelForm.controls.family.disable();

  } // End function saveEasel


  changeEaselType() {
    console.log('-->--> Cambiando valor del selector de tipo de caballete.');
    // this.easelTypeListAux = this.easelTypeList.filter( item => this.easelForm.controls.type.value === item.id);
    this.easelFamilyListAux = this.easelFamilyList.filter( item => this.easelForm.controls.type.value === item.easel_type_id);
    this.easelForm.controls.family.setValue(null);
  } // End function buttonEaselType

  changeEaselFamily() {
    console.log('-->--> Cambiando valor del selector de familia.');
    // this.easelFamilyListAux = this.easelFamilyList.filter( item => this.easelForm.controls.family.value === item.id);
  } // End function changeEaselFamily

  changeFlete() {
    console.log('-->--> Cambiando valor del selector de fletes.');
    // this.freightListAux = this.freightList.filter( item => this.easelForm.controls.id_freight.value === item.id);
  } // End function buttonEaselType


  // ------------------------------------
  //    VALIDACIÓN FINAL DEL FORMULARIO
  // ------------------------------------

  validateEasel(): void {

    // Se realizan las comprobaciones pertinentes para confirmar que los campos del formulario son correctos.

    if (this.easelForm.valid) {

      console.log('-------> Formulario easelForm correcto.');
      this.showActionModal(true);

    } else {
      console.log('-------> Formulario easelForm NO válido:');
      console.log(this.easelForm);

      this.alertInfo = 'El formulario no está correctamente rellenado:<br>';

      if (this.easelForm.controls.name.value.trim() === '') {
        this.alertInfo += ' - Debe de inscribir un nombre.<br>';
      }

      // if (this.easelForm.controls.id_freight.value === null) {
      //   this.alertInfo += ' - Debe seleccionar un flete.<br>';
      // }

      if (this.easelForm.controls.type.value === null) {
        this.alertInfo += ' - Debe seleccionar el tipo de caballete.<br>';
      }

      // if (this.easelForm.controls.utilization.value === null) {
      //   this.alertInfo += ' - Debe indicar la utilización.<br>';
      // }

      if (this.easelForm.controls.thickness.value === null) {
        this.alertInfo += ' - Debe indicar la profundidad.<br>';
      }

      if (this.easelForm.controls.separator.value === null) {
        this.alertInfo += ' - Debe indicar el separador.<br>';
      }

      if (this.easelForm.controls.stack_distance.value === null) {
        this.alertInfo += ' - Debe indicar la distancia entre pilas.<br>';
      }

      if (this.easelForm.controls.priority.value === null) {
        this.alertInfo += ' - Debe indicar la prioridad.<br>';
      }

      if (this.easelForm.controls.cost_m3.value === null) {
        this.alertInfo += ' - Debe indicar el precio.<br>';
      }

      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
    }
  } // End function validateEasel


  getTypeName(idIn: bigint): string {

    const aux = this.easelTypeList.find( item => idIn === item.id);

    console.log('aux:' + aux);

    if (aux !== undefined) {
      if (aux.active !== true) {
        return aux.name + ' (no activo)';
      }
    }
    return aux !== undefined ? aux.name : '(no existe)';
  } // End function getTypeName

  getFreightName(idIn: bigint): string {

    const aux = this.freightList.find( item => idIn === item.id);

    if (aux !== undefined) {
      if (aux.active !== true) {
        return aux.name + '(no activo)';
      }
    }
    return aux !== undefined ? aux.name : '(no existe)';
  } // End function getFreightName

  // ------- Función de regreso
  back(): void {
    // this._location.back();
    this.router.navigate(['/easel']);
  } // End function back

  // -----------------------------------------------
  //  FUNCIONES PARA EL CONTROL DE VENTANAS MODALES
  // -----------------------------------------------

  showActionModal(value: boolean) {
    this.actionModal = value;

  } // End function showActionModal

  confirmActionModal() {

    console.log('--> - -> Confirmada acción del modal.');

    this.saveEasel();

    this.showActionModal(false);
  } // End function confirmActionModal

} // End Class EaselEditComponent
